<template>
  <div class="subscribe-course-section">
    <div class="subscribe-course-section-left">
      <img src="/img/request-a-course.png" />
    </div>
    <div class="subscribe-course-section-right">
      <h4 class="title">Request a course</h4>
      <b-form
        class="row request-course-form"
        data-vv-scope="request"
        v-if="show"
      >
        <b-form-group
          id="input-group-1"
          label=""
          label-for="input-1"
          description=""
          class="col-12"
        >
          <b-form-input
            id="input-1"
            type="text"
            required
            placeholder="Name*"
            v-validate="'required|alpha_spaces|max:20|min:3'"
            name="Name"
            v-model.trim="name"
            :class="{ 'is-invalid': errors.has('request.Name') }"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            <small>{{ errors.first("request.Name") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label=""
          label-for="input-2"
          description=""
          class="col-6"
        >
          <b-form-input
            id="input-2"
            type="email"
            v-validate="'required|email'"
            placeholder="Email*"
            name="email"
            v-model="email"
            :class="{ 'is-invalid': errors.has('request.email') }"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            <small>{{ errors.first("request.email") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label=""
          label-for="input-3"
          description=""
          class="col-6"
        >
          <b-form-input
            id="input-3"
            type="text"
            required
            placeholder="Phone*"
            v-validate="'required|min:10|max:10|numeric'"
            data-ismobileonly="false"
            name="phone number"
            v-model="phnNo"
            :class="{
              'is-invalid': errors.has('request.phone number')
            }"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            <small>{{ errors.first("request.phone number") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label=""
          label-for="input-3"
          description=""
          class="col-12"
        >
          <v-select
            id="teacher-subjects"
            v-model="category"
            :options="categories"
            label="category_name"
            :close-on-select="true"
            placeholder="Course Category*"
            name="Course Category"
            v-validate="'required'"
            :class="{ 'is-invalid': errors.has('request.Course Category') }"
          />
          <b-form-invalid-feedback
            id="add-course-error-feedback"
            style="display: block"
          >
            <small>{{ errors.first("request.Course Category") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="input-group-4"
          label-for="input-4"
          description=""
          class="col-12"
        >
          <b-form-input
            id="input-4"
            type="text"
            required
            placeholder="Course Title*"
            name="Course Title"
            v-model="courseTitle"
            :class="{ 'is-invalid': errors.has('request.Course Title') }"
            v-validate="
              'required|regex:^[A-Za-z0-9 _-]*[A-Za-z0-9][A-Za-z0-9 _-]*$|min:3|max:30'
            "
            autocomplete="off"
          ></b-form-input>
          <b-form-invalid-feedback id="input-1-live-feedback">
            <small>{{ errors.first("request.Course Title") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="input-group-4"
          label-for="input-4"
          description=""
          class="col-12"
        >
          <b-form-textarea
            id="input-4"
            type="text"
            required
            placeholder="Message*"
            name="Message"
            v-model="message"
            :class="{ 'is-invalid': errors.has('request.Message') }"
            v-validate="'required|min:5'"
            autocomplete="off"
            rows="3"
          ></b-form-textarea>
          <b-form-invalid-feedback id="input-1-live-feedback">
            <small>{{ errors.first("request.Message") }}</small>
          </b-form-invalid-feedback>
        </b-form-group>
        <b-button
          v-b-modal.registeration-success-modal
          size="lg"
          pill
          variant="primary"
          type="submit"
          @click.prevent="action('request')"
        >
          <span>Send Your Request</span>
          <font-awesome-icon icon="arrow-right" size="xs" />
        </b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { customerApi } from "../services/customerApi";

export default {
  name: "request-course",
  data() {
    return {
      message: "",
      courseTitle: "",
      category: null,
      phnNo: "",
      email: "",
      name: "",
      categories: [],
      showRequestError: false,
      show: true
    };
  },
  computed: {
    ...mapGetters("category", ["getCategoryData"]),
    ...mapGetters("user", ["isAuthenticated", "getUserRole"])
  },
  methods: {
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result && this.category) {
          this.showRequestError = false;
          this.requestNow();
        } else {
          this.showRequestError = true;
        }
      });
    },
    requestNow() {
      const requestData = {
        name: this.name,
        email: this.email,
        phone: this.phnNo,
        category: this.category.category_name,
        category_id: this.category.category_id,
        course_title: this.courseTitle,
        course_description: this.message
      };
      customerApi
        .requestACourse(requestData)
        .then(res => {
          this.$bvToast.toast("Request Sent Successfully", {
            title: "Request A Course",
            autoHideDelay: 500,
            appendToast: true
          });
          setTimeout(() => {
            if (this.isAuthenticated) {
              this.$router.push({
                path: "/student/dashboard",
                query: {
                  role: this.getUserRole
                }
              });
            } else {
              this.$router.push("/");
            }
          }, 500);
          this.resetForm();
        })
        .catch(e => {
          this.$bvToast.toast("Request Sending failed", {
            title: "Request A Course",
            autoHideDelay: 500,
            appendToast: true
          });
          this.resetForm();
        });
    },
    resetForm() {
      this.name = "";
      this.message = "";
      this.courseTitle = "";
      this.category = "";
      this.email = "";
      this.phnNo = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  mounted() {
    this.getCategoryData.forEach(category => {
      this.categories.push({
        category_name: category.name,
        category_id: category.category_id
      });
      category.sub_category.forEach(sub => {
        this.categories.push({
          category_name: sub.name,
          category_id: sub.category_id
        });
        if (sub.sub_category.length > 0) {
          sub.sub_category.forEach(cat => {
            this.categories.push({
              category_name: cat.name,
              category_id: cat.category_id
            });
          });
        }
      });
    });
    // this.category = this.categories[0]
  }
};
</script>

<style scoped></style>
